<template>
  <div>
    <div class="page_title">商户管理</div>
    <div class="firstLabel">
      <span>所有加盟商户</span>
      <button class="button add" @click="addPartner()">新增商户</button>
    </div>
    <div class="form_row">
      <div class="form_label">区域:</div>
      <div class="form_value">
        <select class="pullDown" @change="changeProvince($event)">
          <option v-for="(item,index) of provinces" :key="index" :value="item.name">
            {{ item.name }}
          </option>
        </select>
        <select class="pullDown" @change="changeCity($event)">
          <option v-for="(item,index) of citys" :key="index" :value="item.name">
            {{ item.name }}
          </option>
        </select>
        <select class="pullDown" @change="changeDistrict($event)">
          <option v-for="(item,index) of districts" :key="index" :value="item">
            {{ item }}
          </option>
        </select>
      </div>
    </div>
    <div class="form_row">
      <div class="form_label">类型:</div>
      <select class="form_value radius" v-model="currentType" @change="changeType">
        <option v-for="(item,index) of serviceTypes" :key="index" :value="item.id">{{item.name}}</option>
      </select>
    </div>
    <div class="form_row">
      <div class="form_label">商家名:</div>
      <input class="form_value radius" v-model="currentName">
    </div>
    <div class="form_row">
      <div class="form_label">状态:</div>
      <select class="form_value radius" v-model="currentState" @change="changeType">
        <option v-for="(item,index) of states" :key="index" :value="item.id">{{item.name}}</option>
      </select>
    </div>

    <table class="table">
      <thead>
      <tr>
        <td>商家名</td>
<!--        <td>联系电话</td>-->
        <td>状态</td>
<!--        <td>操作</td>-->
      </tr>
      </thead>
      <tbody>
      <tr v-for="item of partnerList" :key="item.openId" @click="goViewPartner(item)">
        <td>{{ item.name }}</td>
<!--        <td>{{ item.phone }}</td>-->
        <td v-if="item.state == 1">工作中</td>
        <td v-else-if="item.state == 2">待审批</td>
        <td v-else>未知状态</td>
        <td>
<!--          <button class="button edit" @click="revisePar(item)">修改</button>-->
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { getArea } from "../api";
import { getPartnerDetailList } from "../graphql/api";
export default {
  name: "partner_mgr",
  data(){
    return {
      provinces: [],  //省
      citys: [],      //市
      districts: [],   //区
      currentProvince: null, //当前省份
      province: '',
      currentCity: null,     //当前城市
      city: '',
      currentDistrict: null, //当前区
      district: '',

      serviceTypes: [
        {
          id: null,
          name: '不限'
        },
        {
          id: 1,
          name: '智能洗车'
        },{
          id: 2,
          name: '自助洗车'
        },{
          id: 3,
          name: '人工洗车'
        }
      ],
      currentType: null,
      currentName: '',
      name: '',

      states: [{
        id: null,
        name: '不限'
      },{
        id: 1,
        name:'工作中'
      },{
        id: 2,
        name:'待审批'
      }],
      currentState: null,
      partnerState: [],

      partnerList: []
    }
  },
  watch: {
    currentProvince:function(){
      this.getPartnerList()
    },
    currentCity:function(){
      this.getPartnerList()
    },
    currentDistrict:function(){
      this.getPartnerList()
    },
    currentType:function(){
      this.getPartnerList()
    },
    currentName:function(){
      this.getPartnerList()
    },
    currentState:function(){
      this.getPartnerList()
    },
  },
  mounted(){
    this.queryArea();
    this.getPartnerList();
  },
  methods: {
    addPartner(){
      this.$router.push('/add_partner')
    },

    // 请求商家信息列表
    getPartnerList(){
      if(this.currentName){
        this.name = this.currentName
      }else{
        this.name = null;
      }

      if(this.currentProvince == '不限'){
        this.province = null;
        this.city = null;
        this.district = null;
      }else{
        this.province = this.currentProvince;
        this.city = this.currentCity;
        this.district = this.currentDistrict;
      }

      if(this.currentState == 1){
        this.partnerState = [1]
      }else if(this.currentState == 2){
        this.partnerState = [2]
      }else{
        this.partnerState = [1,2]
      }
      let params = {
        partnerName: this.name,
        province: this.province,
        city: this.city,
        district: this.district,
        contactName: null,
        stateList: this.partnerState,
      }
      getPartnerDetailList(params).then(res => {
        console.log('查询商家信息列表', res);
        this.partnerList = res.data.queryPartner;
      })
    },

    // 查询全国省市区信息
    queryArea(){
      getArea().then(res => {
        console.log('查询到全国省市区信息', res);
        this.provinces = res.data;
        this.citys = this.provinces[0].city;
        this.districts = this.citys[0].area;
      })
    },

    // 切换省份
    changeProvince(event){
      console.log('当前省份',event.target.value);
      this.currentProvince = event.target.value;
      for(const item of this.provinces){
        if(item.name === this.currentProvince){
          this.citys = item.city;
          this.districts = this.citys[0].area;
        }
      }
    },

    // 切换城市
    changeCity(event){
      console.log('当前城市', event.target.value);
      this.currentCity = event.target.value;
      for(const item of this.citys){
        if(item.name === this.currentCity){
          this.districts = item.area;
        }
      }
    },

    // 切换区
    changeDistrict(event){
      console.log('当前区', event.target.value);
      this.currentDistrict = event.target.value;
    },

  //   切换服务类型
    changeType(){
      console.log('切换服务类型', this.currentType);
    },

    // 查看商家详情
    goViewPartner(item){
      this.$router.push({
        name: 'add_partner',
        params: {
          partner: item
        }
      });
    }

  }
}
</script>

<style src="../css/partner_mgr.css"  scoped>

</style>



// WEBPACK FOOTER //
// src/views/partner_mgr.vue